module.exports = __webpack_public_path__ + "img/3_107.1e33ca5a.png";